var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperflite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.313393 5.66833L4.92528 7.91959L-0.000134456 9.96984V7.78894C-0.00516351 7.71868 -0.00516351 7.64815 -0.000134456 7.57788C0.0194399 6.93044 0.124858 6.28839 0.313393 5.66833Z",
    fill: "#E27927"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79646 8.86432L0 14.3618V9.96985L4.9153 7.9196L6.64475 8.76382L6.79646 8.86432Z",
    fill: "#E7445C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.3618L6.79646 8.86432L6.90771 9.42713L2.44754 13.6784L0 16V14.3618Z",
    fill: "#E42B62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44727 13.6784L6.90744 9.43718L7.18051 10.5126V10.6432L6.5838 15.7789C5.01783 15.5258 3.57112 14.7912 2.44727 13.6784Z",
    fill: "#C92D47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58398 15.7889L7.16047 10.6533V10.5528L8.17185 13.9397L7.474 15.8894C7.21104 15.8693 6.8874 15.8392 6.58398 15.7889Z",
    fill: "#994581"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54729 10.1809L8.22238 13.9397L7.19078 10.5528L7.18066 10.5126L8.03022 9.43718L9.54729 10.1809Z",
    fill: "#77335E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54752 10.1809L14.4932 12.603C14.2432 12.9616 13.9623 13.2978 13.6537 13.608C12.3662 14.9282 10.6423 15.7419 8.7991 15.8995C8.52962 15.9148 8.25948 15.9148 7.99 15.8995H7.51465L8.2125 13.9498L9.54752 10.1809Z",
    fill: "#563B81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4935 12.603L9.54785 10.1809L11.2874 5.28644L15.5656 10.5528C15.322 11.2892 14.9599 11.9816 14.4935 12.603Z",
    fill: "#3296C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3177 5.23618L13.9979 2.69347C15.3232 4.12843 16.0467 6.01228 16.0206 7.9598C16.0252 8.83749 15.8851 9.71 15.606 10.5427L11.3076 5.27638L11.3177 5.23618Z",
    fill: "#20BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21191 1.43719L8.37373 0C8.91528 0.0264357 9.45341 0.100426 9.98183 0.221106C10.9415 0.455831 11.8453 0.875867 12.6417 1.45729L11.3067 5.24623L8.21191 1.43719Z",
    fill: "#60C4B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25785 0.904579L6.21992 7.37694L4.92536 7.91965L0.313477 5.6684C0.691632 4.40352 1.38777 3.25519 2.33623 2.33171C2.90125 1.76307 3.54901 1.28199 4.25785 0.904579ZM8.21234 1.43724L7.0796 5.62584e-05C7.38619 -0.0151962 7.69336 -0.0151962 7.99995 5.62584e-05H8.37416L8.21234 1.43724Z",
    fill: "#69B190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21989 7.37688L4.25781 0.904519C5.13236 0.437306 6.09142 0.146956 7.07956 0.0502472L8.2123 1.44723L7.59536 6.81407L6.21989 7.37688Z",
    fill: "#4496B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3075 5.24622L7.56543 6.82411L8.21271 1.43718L11.3075 5.24622Z",
    fill: "#3E96BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3076 5.24624L12.6426 1.45729C13.0009 1.72003 13.339 2.00894 13.654 2.32161L13.9878 2.68342L11.3177 5.22613L11.3076 5.24624Z",
    fill: "#60C4B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2867 5.28644L9.54715 10.1809L8.01997 9.43719L7.18053 10.5226L7.34235 9.10553V9.04523L11.226 5.34674H11.2766L11.2867 5.28644ZM6.6445 8.76382L4.91504 7.9196L6.21972 7.37689L7.58508 6.81408L11.2058 5.28644H11.2867L11.2159 5.34674L6.7962 8.85428L6.6445 8.76382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90813 9.42714L6.79688 8.86433L6.80699 8.84423L11.2267 5.31659L7.34302 9.01508L7.28234 9.07538L7.33291 9.09548L7.1812 10.5126L6.90813 9.42714Z",
    fill: "#DADAD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2564 5.28644L9.51688 10.191L7.9897 9.44724L7.14014 10.5226L7.31207 9.11558V9.04523L11.2059 5.32664H11.2564V5.28644ZM6.61422 8.77387L4.88477 7.92965L6.18944 7.38694L7.56492 6.81408L11.1755 5.29649H11.2564L11.1958 5.35679L6.76593 8.86433L6.61422 8.77387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87785 9.43718L6.7666 8.87437L6.77672 8.85427L11.2066 5.32663L7.32286 9.01507L7.25206 9.07537L7.31275 9.10552L7.14081 10.5126L6.87785 9.43718Z",
    fill: "#DADAD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperflite);
export default __webpack_public_path__ + "static/media/paperflite.a337cb2f852e81ecbe1e86dc6efc7ad6.svg";
export { ForwardRef as ReactComponent };